import qs from 'qs';
import Store, { RootState } from '@/stores';
const BASE_URL = 'https://api.heishigongye.com';

const getToken = () => {
  const state = Store.store.getState() as RootState;
  const tokenInfo = state.Token?.info || {};
  return {
    accessToken: (tokenInfo as any).accessToken || '',
    tokenType: (tokenInfo as any).tokenType || '',
  };
};

class Http {
  async get(params: { url: string; headers?: Record<string, string> }) {
    const { url, headers = {} } = params;
    const { accessToken, tokenType } = getToken();
    return fetch(`${BASE_URL}/${url}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `${tokenType} ${accessToken}`,
        ...headers,
      },
    }).then(response => {
      if(response.status === 401) {
        window.location.href = '/';
      } else {
        return response.json()
      }
    });
  }
  async postFormData(params: { url: string; data: any; headers?: Record<string, string> }) {
    const { url, data, headers = {} } = params;
    const { accessToken, tokenType } = getToken();
    return fetch(`${BASE_URL}/${url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;chartset=UTF-8',
        'Authorization': `${tokenType} ${accessToken}`,
        ...headers,
      },
      body: qs.stringify(data),
    }).then(response => {
      if(response.status === 401) {
        window.location.href = '/';
      } else {
        return response.json()
      }
    });
  }

  async post(params: { url: string; data: any; headers?: Record<string, string> }) {
    const { url, data, headers = {} } = params;
    const { accessToken, tokenType } = getToken();
    return fetch(`${BASE_URL}/${url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `${tokenType} ${accessToken}`,
        ...headers,
      },
      body: JSON.stringify(data),
    }).then(response => {
      if(response.status === 401) {
        window.location.href = '/';
      } else {
        return response.json()
      }
    });
  }

  async put(params: { url: string; data: any; headers?: Record<string, string> }) {
    const { url, data, headers = {} } = params;
    const { accessToken, tokenType } = getToken();
    return fetch(`${BASE_URL}/${url}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `${tokenType} ${accessToken}`,
        ...headers,
      },
      body: JSON.stringify(data),
    }).then(response => {
      if(response.status === 401) {
        window.location.href = '/';
      } else {
        return response.json()
      }
    });
  }
}

const Https = new Http();
export default Https;